/**
 * 数据录入菜单
 */
export default [
  {
    label: 'dataInput',  // 数据录入
    permission: 'hr_cofco_data_center_input',
    img: true,
    id: 24,
    children: [
      {
        path: '/v2/data-input/overall-budget',
        label: 'overallBudget',  // 总体预算
        permission: 'hr_cofco_data_center_input_budget',
        id: 24 - 1
      },
      {
        path: '/v2/data-input/employee-compensation',
        label: 'employeeCompensation', // 员工薪酬水平
        permission: 'hr_cofco_data_center_input_range',
        id: 24 - 2
      }
    ]
  }
]
